export const tempList = [
  { key: 'hyd', title: "华严殿", apiPrefix: "mini" },
  { key: 'ysd', title: "药师殿", apiPrefix: "ysd" },
];
export const defaultTemp = tempList[0].key;

export const routeNameMap = {
  NicheOverview: "overview",
  NicheOrder: "order",
  GoodsList: "goods",
  NicheDistrict: "set/niche-district",
  NicheArea: "set/niche-area",
  NicheIcon: "set/niche-icon",
  LightIntro: "set/intro",
  NicheList: "set/niche-list",
};

export const getTempMenu = function (routeName) {
  let res = null;
  const name = routeNameMap[routeName];
  if (name) {
    res = tempList.map((item) => {
      return {
        title: item.title,
        path: `/${item.key}/worship-light/${name}`,
      };
    });
    // res = [
    //   {
    //     title: "华严殿",
    //     path: `/hyd/worship-light/${name}`,
    //     icon: "table",
    //   },
    //   {
    //     title: "药师殿",
    //     path: `/ysd/worship-light/${name}`,
    //     icon: "profile",
    //   },
    // ];
  }
  return res;
};
